module.exports = __webpack_public_path__ + "media/NorCod med i TERRAVERA Business Program.be1d5c27.mp4";